import React, { useEffect, useState, useRef } from "react";
import { ChevronDown } from "lucide-react";
import "../../css/splash/header.css";

import landingPoster from "../../assets/splash/landingLoadPic.png";

const HEADER_TEXT = "ENGINEERING\nTHE FUTURE\nOF SPACE";

const VideoComponent = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) {
      console.log("Video ref is null");
      return;
    }

    console.log("Video element found:", video);
    console.log("Video src:", video.currentSrc);
    console.log("Video readyState:", video.readyState);

    // Try to play the video
    const playVideo = () => {
      console.log("Attempting to play video...");
      const playPromise = video.play();
      
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            // Video started playing successfully
            console.log("Video autoplay started successfully!");
          })
          .catch(error => {
            // Autoplay was prevented
            console.log("Video autoplay prevented:", error.message);
            console.log("Full error:", error);
            // Fallback: Try again on user interaction
            document.addEventListener('click', () => {
              console.log("Trying to play on user click...");
              video.play();
            }, { once: true });
          });
      }
    };

    // Wait for the video to be ready
    if (video.readyState >= 3) {
      // Video is already loaded enough to play
      console.log("Video already loaded, playing now");
      playVideo();
    } else {
      // Wait for video to load
      console.log("Waiting for video to load...");
      video.addEventListener('loadeddata', () => {
        console.log("Video data loaded, playing now");
        playVideo();
      }, { once: true });
    }

    return () => {
      video.removeEventListener('loadeddata', playVideo);
    };
  }, []);

  return (
    <video
      ref={videoRef}
      autoPlay
      loop
      muted
      playsInline
      preload="auto"
      poster={landingPoster}
      className="header-video"
      onError={(e) => {
        console.log("Video error event:", e);
        console.log("Video error code:", e.target.error?.code);
        console.log("Video error message:", e.target.error?.message);
      }}
      onLoadStart={() => console.log("Video load started")}
      onLoadedMetadata={() => console.log("Video metadata loaded")}
      onLoadedData={() => console.log("Video data loaded")}
      onCanPlay={() => console.log("Video can play")}
      onPlaying={() => console.log("Video is playing")}
      onPause={() => console.log("Video paused")}
    >
      <source src="/landing-vid.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
};

export const Header = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToBottom = () => {
    const headerElement = document.getElementById("splash-header");
    const navbarElement = document.getElementsByClassName("header")[0];
    if (headerElement && navbarElement) {
      const headerBottom = headerElement.offsetTop + headerElement.offsetHeight;
      const navbarHeight = navbarElement.offsetHeight;
      window.scrollTo({
        top: headerBottom - navbarHeight,
        behavior: "smooth",
      });
    }
  };

  const parallaxStyle = {
    transform: `translateY(${scrollY * 0.5}px)`,
  };

  const contentParallaxStyle = {
    transform: isMobile 
      ? `translateX(-50%) translateY(${scrollY * 0.3}px)` 
      : `translateY(${scrollY * 0.3}px)`,
    opacity: Math.max(0, 1 - scrollY / 400),
  };

  return (
    <div className="splash-header" id="splash-header">
      <VideoComponent />

      <div className="content-wrapper" style={contentParallaxStyle}>
        <h1>{HEADER_TEXT}</h1>
      </div>

      {!isMobile && (
        <button
          className="scroll-arrow"
          onClick={scrollToBottom}
          aria-label="Scroll to content"
        >
          <ChevronDown size={48} strokeWidth={2.5} />
        </button>
      )}

      <div className="gradient-overlay"></div>
    </div>
  );
};
